<template>
  <section
    v-if="message"
    class="individual-rating"
  >
    <h4>X Ind Performance Modifier</h4>
    <div>
      <template v-if="!value">
        <span>{{ message }}</span><span>X TBD</span>
      </template>
      <template v-else>
        <span>{{ message }}</span><span>X {{ formatPercent(value, 2) }}</span>
      </template>
    </div>
  </section>
</template>

<script>
import VLpercent from '@/composables/VLpercent';

export default {
    name: "IndividualRating",

    props: {
        tbd: {
            type: Boolean,
            default: true,
        },
        message: {
            type: String,
            required: true,
        },
        value: {
            type: Number,
            required: true,
        }
    },

    data() {
        return {}
    },

    computed: {},

    methods: {
        formatPercent(value, decimals = 0) {
            return VLpercent.formatPercent(value, decimals);
        }
    },
}
</script>

<style lang="scss" scoped>
@use "../../../../scss/_variables.scss";

.individual-rating {
    font-size: variables.$text-sm;

    margin-bottom: 1rem;

    div {
        display: flex;
        justify-content: space-between;

        span {

            &:last-child {
                font-weight: 800;
                font-size: variables.$text-base;
                color: var(--highlight-color);
            }
        }

    }
}
</style>